/* lkp2-17.js - audit fixes (19/10/2026). Loads after every other lkp2 file and only wraps P.prototype methods.
   1) One Front / Reverse / Front & reverse control for two-sided pick products (tie clips): variant and property always agree.
   2) Sample wording is drawn faint and italic while a field is empty, and never on the Review step.
   3) Each step is checked when you move on; errors sit next to the field, never on steps you have not reached.
   4) Parker pen: Blue / Black barrels tinted on the preview photo; gift extras listed on Review and in the cart.
   5) "No, send it blank" keeps the colour picker; scannable (Spotify / QR) products have no blank option.
   6) Spotify field: clear label, link check, neutral sample code + note.
   7) Simpler wording: one step counter, "Reverse" side, "Add to basket", "Style", no "Also choose", no Remove on required choices,
      Review lists colour / sides / options / extras, character-limit warning, capitals shown exactly as engraved. */
(function () {
  'use strict';
  var K = window.__lkp2k, P = K && K.P;
  if (!P || P.prototype._lkAudit) return;
  P.prototype._lkAudit = 1;
  var lc = K.lc, esc = K.esc, h = K.h, money = K.money;
  var GHOST = 0.28, GHOST_BOX = 0.55;
  var SPOT = /^(https?:\/\/)?([a-z0-9-]+\.)*(spotify\.com|spotify\.link|spoti\.fi)\/\S+$|^spotify:\S+$/i;

  var css = document.createElement('style');
  css.textContent = [
    '.lkp2__shead small[data-sidx]{display:none!important}',
    '.lkp2__xo>div.lk-xo-off{display:none!important}',
    '.lk-sides{margin:0 0 14px}.lk-sides .lkp2__label{font-size:13px!important;font-weight:600!important;letter-spacing:.04em!important;text-transform:uppercase!important;color:#4a4638!important;margin:0 0 8px!important}',
    '.lk-sides__g{display:grid;grid-template-columns:repeat(3,1fr);gap:8px}',
    '.lk-sides__b{min-height:52px;padding:8px 6px;border:1px solid #cfc6ba;border-radius:8px;background:#fff;font:inherit;font-size:15px;font-weight:600;color:#1b1c1e;cursor:pointer;line-height:1.2;text-align:center}',
    '.lk-sides__b small{display:block;font-weight:400;font-size:12px;color:#6b6560;margin-top:2px}',
    '.lk-sides__b[aria-checked=true]{border:2px solid #9c7a3c;color:#7c6130}',
    '.lkp2__sw{position:relative}.lkp2__sw.lk-two i{background:linear-gradient(90deg,#d4d7dc 50%,#e2c26b 50%)!important}',
    '.lk-swl{display:block;font-size:11px;line-height:1.2;color:#5b5d62;text-align:center;margin-top:4px;white-space:nowrap}',
    '.lkp2__swatches{row-gap:10px}',
    '.lkp2__sw{overflow:visible!important}',
    '.lk-spnote{margin:6px 0 0;font-size:13px;color:#5b5d62}',
    '.lkp2__summary li.lk-rv .lkp2__sval{font-weight:400}',
    '.lk-limit{color:#8a5a00!important}'
  ].join('');
  document.head.appendChild(css);

  /* ---------- config tidy: "Reverse" side, "Style" label, Spotify label, no blank option on scannable products ---------- */
  function tidyCfg(me) {
    var c = me.cfg; if (!c || c._lkAudit) return; c._lkAudit = 1;
    var scan = false;
    (c.faces || []).forEach(function (f) {
      if (/^back$/i.test(f.label || '')) f.label = 'Reverse';
      else if (/\(back\)/i.test(f.label || '')) f.label = String(f.label).replace(/\(back\)/i, '(reverse)');
      var all = [].concat(f.fields || []);
      (f.modes || []).forEach(function (m) { all = all.concat(m.fields || []); });
      all.forEach(function (fd) {
        if (!fd) return;
        if (fd.type === 'spotify' || fd.type === 'qr') scan = true;
        if (fd.type === 'spotify') { fd.label = 'Song link (Spotify)'; fd.placeholder = 'Paste the song link from Spotify'; }
        if (fd.type === 'select' && /^design$/i.test(fd.label || '')) fd.label = 'Style';
      });
    });
    if (scan) { c.engraveToggle = false; me.st.engrave = true; }
  }
  var oBuild = P.prototype.build;
  P.prototype.build = function () { tidyCfg(this); return oBuild.apply(this, arguments); };

  /* ---------- 1) one sides control for two-sided pick products (tie clips) ---------- */
  P.prototype.lkSides = function () {
    var c = this.cfg && this.cfg.count; if (!c || !c.pick || !c.values || !c.option) return null;
    var oi = this.optIndex && this.optIndex[lc(c.option)]; if (oi == null) return null;
    var ci = this.countInfo(); if (!ci || ci.counted.length !== 2) return null;
    var one = null, two = null;
    Object.keys(c.values).forEach(function (k) { if (c.values[k] === 1) one = k; else if (c.values[k] === 2) two = k; });
    if (!one || !two) return null;
    return { oi: oi, one: one, two: two, a: ci.counted[0], b: ci.counted[1], name: c.option };
  };
  P.prototype.lkSideKey = function (S) {
    S = S || this.lkSides(); if (!S || !this.variant) return null;
    if (this.variant.o[S.oi] === S.two) return 'both';
    var p = this.st.picked || [];
    return p[0] === S.b.id ? 'b' : 'a';
  };
  P.prototype.lkSideLabel = function (S, k) {
    k = k || this.lkSideKey(S);
    return k === 'both' ? S.a.label + ' & ' + lc(S.b.label) : k === 'b' ? S.b.label : S.a.label;
  };
  P.prototype.lkChooseSide = function (k) {
    var me = this, S = this.lkSides(); if (!S) return;
    var v = this.xoMatch(S.oi, k === 'both' ? S.two : S.one);
    var done = function () {
      me.st.picked = k === 'both' ? [S.a.id, S.b.id] : [k === 'b' ? S.b.id : S.a.id];
      me.st.active = me.st.picked[0];
      me._sig = null; me.sync();
    };
    if (v && !(this.variant && this.variant.id === v.id)) this.selectVariant(v.id, done); else done();
  };
  P.prototype.lkSidesUI = function () {
    var S = this.lkSides(); if (!S || !this.elXo) return;
    var me = this, grp = this.elXo.querySelector('[data-xo="' + S.oi + '"]');
    if (grp) grp.classList.add('lk-xo-off');
    var box = this.elXo.querySelector('.lk-sides');
    if (!box) {
      box = h('div', { class: 'lk-sides' });
      box.innerHTML = '<p class="lkp2__label">Sides to engrave</p><div class="lk-sides__g" role="radiogroup" aria-label="Sides to engrave">' +
        ['a', 'b', 'both'].map(function (k) { return '<button type="button" class="lk-sides__b" role="radio" data-lkside="' + k + '"></button>'; }).join('') + '</div>';
      box.addEventListener('click', function (e) { var b = e.target.closest('[data-lkside]'); if (b) me.lkChooseSide(b.getAttribute('data-lkside')); });
      this.elXo.insertBefore(box, grp || this.elXo.firstChild);
    }
    var cur = this.lkSideKey(S), v1 = this.xoMatch(S.oi, S.one), v2 = this.xoMatch(S.oi, S.two);
    box.querySelectorAll('[data-lkside]').forEach(function (b) {
      var k = b.getAttribute('data-lkside'), v = k === 'both' ? v2 : v1;
      b.setAttribute('aria-checked', String(k === cur));
      b.innerHTML = esc(me.lkSideLabel(S, k)) + (v ? '<small>' + money(v.p) + '</small>' : '');
    });
    if (this.elPick) { this.elPick.hidden = true; }
  };
  var oXS = P.prototype.xoSync;
  if (oXS) P.prototype.xoSync = function () {
    var r = oXS.apply(this, arguments), S = this.lkSides();
    if (S && this.variant) {
      var o = this.variant.o.slice(), lab = this.lkSideLabel(S);
      o[S.oi] = lab;
      this._xoCap = o.filter(function (x) { return x && x !== 'Default Title'; }).join(' · ');
      this.lkSidesUI();
    }
    return r;
  };

  /* ---------- pen gift extras ---------- */
  P.prototype.lkGifts = function () {
    var p = this.product, v = this.variant; if (!p || !v) return null;
    var pk = -1, bag = -1, ref = -1;
    (p.options || []).forEach(function (n, i) { if (/packag/i.test(n)) pk = i; else if (/gift bag/i.test(n)) bag = i; else if (/ink refill/i.test(n)) ref = i; });
    if (pk < 0) return null;
    var a = [], s = String(v.o[pk] || '');
    if (/box/i.test(s)) a.push('Parker gift box');
    if (/pouch/i.test(s)) a.push('Velvet pouch');
    if (bag >= 0 && v.o[bag] === 'Yes') a.push('Parker gift bag');
    if (ref >= 0 && v.o[ref] === 'Yes') a.push('Spare ink refill');
    return a.join(', ');
  };
  var oProps = P.prototype.props;
  P.prototype.props = function () {
    var out = oProps.apply(this, arguments), g = this.lkGifts();
    if (g) out.push(['Gift options', g]);
    return out;
  };

  /* ---------- sync: blank option keeps the colour picker; scannable products never offer blank ---------- */
  var oSync = P.prototype.sync;
  P.prototype.sync = function () {
    if (this.cfg) tidyCfg(this);
    var r = oSync.apply(this, arguments);
    var yn = this.root.querySelector('.lkp2__yn');
    if (yn && this.cfg && this.cfg.engraveToggle === false) yn.hidden = true;
    if (this.isModal() && !this.choices && !this.st.engrave && !this.isBlank() && this.hasFinish()) this.elBody.hidden = false;
    if (this.lkSides()) { if (this.elPick) this.elPick.hidden = true; this.lkSidesUI(); }
    this.lkSwatches();
    return r;
  };
  P.prototype.lkSwatches = function () {
    this.root.querySelectorAll('.lkp2__sw[data-col]').forEach(function (b) {
      var n = b.getAttribute('data-col');
      if (/&| and /i.test(n)) b.classList.add('lk-two');
      if (!b.querySelector('.lk-swl')) { var s = document.createElement('span'); s.className = 'lk-swl'; s.textContent = n; b.appendChild(s); }
    });
  };

  /* ---------- 2) sample wording: faint + italic while empty, never on Review, nothing on a plain (blank) item ---------- */
  var oPlan = P.prototype.plan;
  P.prototype.plan = function (f, ph, W, H) {
    if (this._lkPlain) return { ops: [], err: null, ghost: true, noExample: true, z: this.zonePx(ph, W, H) };
    var r = oPlan.apply(this, arguments);
    if (!r) return r;
    if (ph && ph.pens && !r.ghost) {
      var V = this.vals(f), m = this.modeOf && this.modeOf(f);
      if (!String(V.l1 || '').trim() && !String(V.l2 || '').trim() && !V.icon && !(m && m.id && m.id !== 'text')) r.ghost = true;
    }
    (r.ops || []).forEach(function (o) { if (o.k === 'spotify') o.val = 'lk-sample-code'; });
    if (r.ghost && this.isModal() && this.st.step === 'review') { r.ops = []; r.noExample = true; }
    return r;
  };
  var FONT = Object.getOwnPropertyDescriptor(CanvasRenderingContext2D.prototype, 'font');
  var oDO = P.prototype.drawOps;
  P.prototype.drawOps = function (ctx, plan, k) {
    if (!plan || !plan.ghost || !plan.ops || !plan.ops.length || !FONT) return oDO.apply(this, arguments);
    var boxes = [], rest = [];
    plan.ops.forEach(function (o) { (o.k === 'ph' ? boxes : rest).push(o); });
    var a0 = ctx.globalAlpha, pend = [], me = this;
    var run = function (ops, a, italic) {
      if (!ops.length) return;
      var pl = {}; for (var q in plan) pl[q] = plan[q]; pl.ops = ops;
      ctx.globalAlpha = a0 * a;
      if (italic) try { Object.defineProperty(ctx, 'font', { configurable: true, get: function () { return FONT.get.call(this); }, set: function (v) { FONT.set.call(this, /^(italic|oblique)\b/.test(v) ? v : 'italic ' + v); } }); } catch (e) {}
      try { pend = pend.concat(oDO.call(me, ctx, pl, k) || []); }
      finally { if (italic) try { delete ctx.font; } catch (e) {} ctx.globalAlpha = a0; }
    };
    run(boxes, GHOST_BOX, false);
    run(rest, GHOST, true);
    return pend;
  };
  /* necklace letter charm: very faint until a letter is chosen */
  P.prototype.drawSolid = function (ctx, f, ph, W, H, k, vr) {
    var me = this, D = K.D, ch = null, ghost = false, mctx = this.mctx || (this.mctx = document.createElement('canvas').getContext('2d')), all = [f].concat(this.allFaces());
    all.forEach(function (g) { var V = me.vals(g); me.fieldsOf(g).forEach(function (fd) { var v = String(V[fd.id] || ''); if (!ch && /^[A-Za-z]$/.test(v)) ch = v.toUpperCase(); }); });
    if (!ch) { all.forEach(function (g) { me.fieldsOf(g).forEach(function (fd) { if (!ch && fd.type === 'select') { var o = me.libOptions(fd)[0]; if (o && /^[A-Za-z]$/.test(o.v)) ch = o.v; } }); }); ghost = true; }
    if (!ch) return;
    if (ghost && this.isModal() && this.st.step === 'review') return;
    var z = this.zonePx(ph, W, H), m = K.METAL[ph.fin] || K.METAL.silver, serif = (D.STYLE_FONTS && D.STYLE_FONTS.serif) || 'serif';
    mctx.font = 'bold 100px ' + serif; var tw = mctx.measureText(ch).width / 100, size = Math.min(z.h * 0.92 / K.CAP, z.w * 0.95 / tw);
    ctx.save(); ctx.setTransform(k, 0, 0, k, -vr.x * k, -vr.y * k); ctx.translate(z.cx, z.cy); ctx.rotate(z.rot);
    ctx.font = 'bold ' + size + 'px ' + serif; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    var g = ctx.createLinearGradient(-z.w / 2, -z.h / 2, z.w / 2, z.h / 2); g.addColorStop(0, m[0]); g.addColorStop(0.5, m[1]); g.addColorStop(1, m[2]);
    ctx.globalAlpha = ghost ? 0.16 : 1;
    if (!ghost) { ctx.shadowColor = 'rgba(40,40,40,.28)'; ctx.shadowBlur = z.h * 0.04; ctx.shadowOffsetY = z.h * 0.015; }
    ctx.fillStyle = g; ctx.fillText(ch, 0, size * 0.04);
    ctx.shadowColor = 'transparent'; ctx.lineWidth = Math.max(1 / k, z.h * 0.012); ctx.strokeStyle = m[2]; ctx.strokeText(ch, 0, size * 0.04);
    ctx.restore();
  };
  /* blank ("No, send it blank"): show the plain piece in the chosen colour */
  var oDS = P.prototype.drawStage;
  P.prototype.drawStage = function () {
    if (this.faces().length || !this.isModal() || this.choices) return oDS.apply(this, arguments);
    var f = this.allFaces()[0], cv = this.cv; if (!f || !cv) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2.5), w = Math.round(cv.clientWidth * dpr), hh = Math.round(cv.clientHeight * dpr);
    if (w < 10 || hh < 10) return;
    if (cv.width !== w || cv.height !== hh) { cv.width = w; cv.height = hh; }
    var me = this; this._lkPlain = true;
    var off = document.createElement('canvas'); off.width = w; off.height = hh;
    this.render(off, f, 'full', { dpr: dpr, single: true, solo: true, again: false }).then(function () {
      me._lkPlain = false; var x = cv.getContext('2d'); x.setTransform(1, 0, 0, 1, 0, 0); x.clearRect(0, 0, w, hh); x.drawImage(off, 0, 0);
      var sp = me.root.querySelector('[data-spin]'); if (sp) sp.classList.remove('is-on');
    }, function () { me._lkPlain = false; });
  };

  /* ---------- 4) Parker pen: Blue / Black barrel on the silver photo ---------- */
  var TINT = { blue: [28, 60, 138], black: [26, 26, 29] };
  var oPL = P.prototype.photoList;
  P.prototype.photoList = function (f, colour) {
    var l = oPL.apply(this, arguments), c = lc(colour);
    (l || []).forEach(function (ph) { if (ph && TINT[c] && /lk-pen-preview-silver\.jpg/.test(ph.src || ph.img || '')) ph.tint = c; });
    return l;
  };
  var oBase = P.prototype.base;
  P.prototype.base = function (ph) {
    if (!ph || !ph.tint) return oBase.apply(this, arguments);
    var key = 'tint|' + ph.tint + '|' + ph.src;
    if (this.bases[key]) return this.bases[key];
    this.bases[key] = oBase.apply(this, arguments).then(function (src) {
      var c = document.createElement('canvas'); c.width = src.width; c.height = src.height;
      var x = c.getContext('2d'); x.drawImage(src, 0, 0);
      try {
        var W = c.width, H = c.height, x1 = Math.round(W * 0.167), y0 = Math.round(H * 0.4), y1 = Math.round(H * 0.67), t = TINT[ph.tint];
        var id = x.getImageData(0, y0, x1, y1 - y0), d = id.data;
        for (var i = 0; i < d.length; i += 4) {
          var l = d[i] * 0.299 + d[i + 1] * 0.587 + d[i + 2] * 0.114; if (l > 240) continue;
          var w = Math.min(1, (240 - l) / 16), kk = l / 172, hl = Math.max(0, l - 200) / 55;
          for (var ch = 0; ch < 3; ch++) { var v = Math.min(255, t[ch] * kk * 1.08 + 255 * hl * 0.3); d[i + ch] = d[i + ch] * (1 - w) + v * w; }
        }
        x.putImageData(id, 0, y0);
      } catch (e) {}
      return c;
    });
    return this.bases[key];
  };

  /* ---------- 3) step-by-step checks, errors next to the field ---------- */
  P.prototype.lkClearErrs = function (keep) {
    if (!this.elPanels) return;
    this.elPanels.querySelectorAll('.lkp2__panel').forEach(function (p) {
      if (p.getAttribute('data-face') === keep) return;
      p.querySelectorAll('[data-err]').forEach(function (e) { e.hidden = true; });
    });
  };
  P.prototype.lkSpotBad = function (f) {
    var V = this.vals(f), bad = null;
    this.fieldsOf(f).forEach(function (fd) { if (fd.type === 'spotify' && V[fd.id] && !SPOT.test(String(V[fd.id]).trim())) bad = fd; });
    return bad;
  };
  P.prototype.lkCheckStep = function (id) {
    var me = this;
    if (id === 'review') return true;
    if (id === 'finish') {
      var ok = true, ce = this.root.querySelector('[data-colerr]');
      if (!this.colourIsVariant && this.cfg.colours && this.cfg.colours.length && !this.st.colour) {
        ok = false; if (ce) { ce.hidden = false; try { ce.parentNode.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {} }
      }
      var ci = this.countInfo();
      if (ok && ci && ci.pick && ci.n && this.faces().length && (this.st.picked || []).length !== ci.n) { ok = false; this.flash('Please choose ' + ci.n + ' ' + this.units(ci.n) + ' to ' + this.verb().act + '.'); }
      return ok;
    }
    var f = this.face(id); if (!f) return true;
    var se = this.st.showErrors; this.st.showErrors = false;
    try { this.validate(false); } finally { this.st.showErrors = se; }
    var msgs = ((this.errs || {})[id] || []).filter(function (m) { return !/tick the box/i.test(m); });
    this.errs = {}; if (msgs.length) this.errs[id] = msgs;
    this.lkClearErrs(id);
    try { this.renderSteps(); } catch (e) {}
    if (!msgs.length) return true;
    var p = this.panelEl(id);
    if (p && !p.querySelector('.lkp2__err:not([hidden])')) {
      var V = this.vals(f), fd0 = null;
      this.fieldsOf(f).forEach(function (fd) { if (!fd0 && fd.required && fd.type !== 'font' && fd.type !== 'icon' && !V[fd.id]) fd0 = fd; });
      var el = fd0 && p.querySelector('[data-err="' + fd0.id + '"]');
      if (el) { el.textContent = fd0.type === 'select' ? 'Please choose one.' : 'Please fill this in.'; el.hidden = false; }
      else { var fe = p.querySelector('[data-fiterr]'); if (fe) { fe.textContent = String(msgs[0]).replace(/^[^:]+:\s*/, '').replace(/^./, function (c) { return c.toUpperCase(); }); fe.hidden = false; } }
    }
    var first = p && p.querySelector('.lkp2__err:not([hidden])');
    if (first) {
      try { first.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
      var fld = first.closest('.lkp2__field'), inp = fld && fld.querySelector('input.lkp2__input,textarea.lkp2__input');
      if (inp) setTimeout(function () { try { inp.focus({ preventScroll: true }); } catch (e) {} }, 300);
    }
    return false;
  };
  var oGS = P.prototype.goStep;
  P.prototype.goStep = function (id) {
    if (this.isModal() && !this._lkGo) {
      var st = this.steps(), i = st.indexOf(this.st.step), j = st.indexOf(id);
      if (i >= 0 && j > i) {
        for (var q = i; q < j; q++) {
          if (!this.lkCheckStep(st[q])) {
            if (q !== i) { this._lkGo = 1; try { oGS.call(this, st[q]); } finally { this._lkGo = 0; } this.lkCheckStep(st[q]); }
            return;
          }
        }
      }
      if (j > i && i >= 0) { this.errs = {}; this.lkClearErrs(null); }
    }
    return oGS.apply(this, arguments);
  };
  var oSE = P.prototype.showErrs;
  P.prototype.showErrs = function () {
    if (this.isModal() && this.st.step !== 'review') { var b = this.root.querySelector('[data-errors]'); if (b) { b.hidden = true; b.innerHTML = ''; } return; }
    return oSE.apply(this, arguments);
  };
  var oVal = P.prototype.validate;
  P.prototype.validate = function (submitting) {
    var ok = oVal.apply(this, arguments), me = this, badF = null;
    this.faces().forEach(function (f) {
      var fd = me.lkSpotBad(f); if (!fd) return;
      me.markErr(me.panelEl(f.id), fd.id, 'Please paste the song link from Spotify (Share, then Copy link).');
      me.errs = me.errs || {}; (me.errs[f.id] = me.errs[f.id] || []).push(f.label + ': please paste the Spotify song link.');
      if (!badF) badF = f;
    });
    if (badF) { if (submitting && this.isModal()) this.goStep(badF.id); return false; }
    return ok;
  };
  var oIn = P.prototype.onInput;
  P.prototype.onInput = function (e) {
    var r = oIn.apply(this, arguments), t = e && e.target;
    if (t && t.getAttribute && t.getAttribute('data-k')) {
      var fld = t.closest('.lkp2__field'), er = fld && fld.querySelector('[data-err]');
      if (er && !er.classList.contains('lk-limit')) er.hidden = true;
      if (er) er.classList.remove('lk-limit');
      if (t.maxLength > 0 && String(t.value).length >= t.maxLength && e.type === 'input') {
        this.fieldNote(t, t.maxLength + ' characters max - shorten it if a word is cut off.');
        if (er) er.classList.add('lk-limit');
      }
    }
    return r;
  };

  /* ---------- 6) Spotify field note ---------- */
  var oFH = P.prototype.fieldHtml;
  P.prototype.fieldHtml = function (f, fd) {
    var s = oFH.apply(this, arguments);
    if (fd && fd.type === 'spotify' && typeof s === 'string') s = s.replace(/<\/div>$/, '<p class="lk-spnote">The preview shows a sample code. Your song\'s code is added when we make it.</p></div>');
    return s;
  };

  /* ---------- 7) wording ---------- */
  function okText(me) { return 'Add to basket'; }
  var oRS = P.prototype.renderSteps;
  P.prototype.renderSteps = function () {
    var r = oRS.apply(this, arguments);
    if (!this.isModal()) return r;
    var st = this.steps(), i = st.indexOf(this.st.step), nx = st[i + 1];
    var next = this.root.querySelector('[data-act="next"]'); if (next && nx === 'review') next.innerHTML = 'Review &rarr;';
    var ok = this.root.querySelector('[data-act="ok"]'); if (ok) ok.textContent = okText(this);
    if (this.elNow && i >= 0) {
      var f = this.face(this.st.step), t = this.st.step === 'finish' ? 'Options' : this.st.step === 'review' ? 'Review' : (f ? f.label : '');
      this.elNow.innerHTML = '<b>Step ' + (i + 1) + ' of ' + st.length + ' · ' + esc(t) + '</b>';
    }
    if (this.elSteps && this.errs) this.elSteps.querySelectorAll('.lkp2__step').forEach(function (b) { if (!this.errs[b.getAttribute('data-step')]) b.classList.remove('has-error'); }, this);
    return r;
  };
  var oSync2 = P.prototype.sync;
  P.prototype.sync = function () {
    var r = oSync2.apply(this, arguments);
    var ok = this.root.querySelector('[data-act="ok"]'); if (ok && this.isModal()) ok.textContent = okText(this);
    return r;
  };
  /* capitals shown exactly as they will be engraved */
  var oDesc = P.prototype.describe;
  P.prototype.describe = function (f) {
    var s = oDesc.apply(this, arguments); if (typeof s !== 'string' || !f) return s;
    var V = this.vals(f), me = this;
    var up = function (fd) { return fd && (fd.tf === 'caps' || fd.tf === 'ini' || fd['case'] === 'upper'); };
    this.fieldsOf(f).forEach(function (fd) {
      if ((fd.type === 'text' || fd.type === 'textarea') && up(fd) && V[fd.id]) s = s.split('"' + V[fd.id] + '"').join('"' + String(V[fd.id]).toUpperCase() + '"');
      if (fd.type === 'select') { var so = me.selOption(f, fd); (so && so.fields || []).forEach(function (sf) { var v = V[fd.id + '.' + sf.id]; if (v && up(sf)) s = s.split(String(v)).join(String(v).toUpperCase()); }); }
    });
    return s;
  };
  /* Review: colour, sides, options and extras first; no Remove on required choices */
  var oSum = P.prototype.renderSummary;
  P.prototype.renderSummary = function () {
    var r = oSum.apply(this, arguments);
    if (!this.isModal() || !this.elSummary) return r;
    var me = this, rows = [], S = this.lkSides(), col = this.colour();
    if (col && ((this.cfg.colours || []).length > 1 || this.colourIsVariant)) rows.push(['Colour', col]);
    if (this.xoList && this.variant) this.xoList().forEach(function (o) {
      if (S && o.i === S.oi) return;
      if (/packag|gift bag|ink refill|^extras$/i.test(o.n)) return;
      if (/colou?r|finish|metal/i.test(o.n) && col) return;
      rows.push([o.n, me.variant.o[o.i]]);
    });
    if (S && this.faces().length) rows.push(['Sides to engrave', this.lkSideLabel(S)]);
    var g = this.lkGifts(); if (g != null) rows.push(['Gift options', g || 'None']);
    this.elSummary.querySelectorAll('[data-remove]').forEach(function (b) { var f = me.face(b.getAttribute('data-remove')); if (f && !me.isOptional(f)) b.remove(); });
    if (rows.length) {
      var html = rows.map(function (x) { return '<li class="is-done lk-rv"><span class="lkp2__sface">' + esc(x[0]) + '</span><span class="lkp2__sval">' + esc(x[1]) + '</span><span class="lkp2__sact">' + (me.hasFinish() ? '<button type="button" data-step="finish">Edit</button>' : '') + '</span></li>'; }).join('');
      var ul = this.elSummary.querySelector('ul');
      if (!ul) { this.elSummary.innerHTML = '<p class="lkp2__label">Your choices</p><ul></ul>'; ul = this.elSummary.querySelector('ul'); }
      ul.insertAdjacentHTML('afterbegin', html);
    }
    return r;
  };

  /* already running (this file loaded after the personaliser started): apply now */
  function late() {
    document.querySelectorAll('[data-lkp2]').forEach(function (el) {
      var m = el.__lkp2; if (!m || !m.cfg || m._lkLate) return; m._lkLate = 1;
      try { tidyCfg(m); m._sig = null; m.sync(); } catch (e) {}
    });
  }
  late(); setTimeout(late, 1500);
})();
